import { render, staticRenderFns } from "./AcceptRequests.vue?vue&type=template&id=d00cebb8&"
import script from "./AcceptRequests.vue?vue&type=script&lang=js&"
export * from "./AcceptRequests.vue?vue&type=script&lang=js&"
import style0 from "./AcceptRequests.vue?vue&type=style&index=0&id=d00cebb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports